import ProductGrid from '../components/ProductGrid';
import Products from '../hooks/Productcall'; // Adjust the import path as necessary
import Hero from '../components/Hero/Hero';

const Store = () => {

  const {productData: productData, error: error, isLoading: isLoading,hasMore:hasMore, fetchProducts: fetchProducts} = Products();

  return (
    <>
      <Hero onCTAClick={() => {}} style={{ minHeight: '140px', height: '50vh', maxHeight: '220px' }} />
      <ProductGrid
        title="Products"
        products={productData}
        isLoading={isLoading}
        error={error}
        hasMore={hasMore}
        fetchMore={fetchProducts}
        //endMessage="No more products to show."
      />
    </>
  );
};

export default Store;
